import { render, staticRenderFns } from "./GeneralInfoFeed.vue?vue&type=template&id=59a9ce4e&scoped=true&"
import script from "./GeneralInfoFeed.vue?vue&type=script&lang=js&"
export * from "./GeneralInfoFeed.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInfoFeed.vue?vue&type=style&index=0&id=59a9ce4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a9ce4e",
  null
  
)

export default component.exports